// Absolute imports
import $ from 'jquery';
import DDTemplates from 'dd-templates';
import Promise from 'promise-polyfill';
// Relative imports
import Menu from './Menu';
import Drupal from './Drupal';
import Header from './Header';
import Gallery from './Gallery';
import Toolbar from './Toolbar';
import MobileMenu from './MobileMenu';
import SmartFooter from './SmartFooter';
import CalendarFeed from './CalendarFeed';
import FixNavigation from './FixNavigation';
import TermNavigation from './TermNavigation';
// Relative theme specific imports
import Strip from './Strip';
import Notification from './Notification';
import BackgroundImage from './BackgroundImage';
import Placeholder from './Placeholder';
import Parallax from './Parallax';
import Expanded from './Expanded';
import TwitterFeed from './TwitterFeed';
import Translate from './Translate';
import NewsSlider from './NewsSlider';
import DistrictAlert from './DistrictAlert';
import SchoolsMenu from './SchoolsMenu';
import DistrictProfiles from './DistrictProfiles';
import DistrictMenu from './DistrictMenu';

// Add Promise to window if not defined.
if (!window.Promise) {
  window.Promise = Promise;
}

// Add the theme behaviors

Drupal.behavior((context) => {
  // Helpers

  const $body = $(document.body, context);

  // DD Template Behaviors

  // eslint-disable-next-line no-new
  new DDTemplates(context);

  // Fix our damn menus from displaying orphaned children

  $('.primary-navigation, .term-nav', context).each((i, element) => {
    if (!element.FixNavigation) {
      element.FixNavigation = new FixNavigation(element);
    }
  });

  // Staff Profiles loaded from the District site.

  $('#profile-directory', context).each((i, element) => {
    if (!element.DistrictProfiles) {
      element.DistrictProfiles = new DistrictProfiles(element);
    }
  });

  // District Menu.

  $('.primary-navigation ul.nice-menu', context).each((i, element) => {
    if (!element.DistrictMenu) {
      const source = '#node-full .node-content ul.district-menu';
      element.DistrictMenu = new DistrictMenu(element, source);
    }
  });

  // Main/Primary Site Navigation

  $('#block-nice_menus-3', context).each((i, element) => {
    if (!element.menu && !element.mobileMenu) {
      element.menu = new Menu(element);
      element.mobileMenu = new MobileMenu(element);
    }
  });

  // Notifications

  $('#block-views_blocks-term-block_1-4', context).each((i, element) => {
    if (!element.Notification) {
      element.Notification = new Notification(element);
    }
  });

  // District Alerts

  $(document.body, context).each((i, element) => {
    if (!element.DistrictAlert) {
      element.DistrictAlert = new DistrictAlert(element);
    }
  });

  // Schools Menu

  $('.schools-menu', context).each((i, element) => {
    if (!element.SchoolsMenu) {
      element.SchoolsMenu = new SchoolsMenu(element);
    }
  });

  // News Slider

  $('#block-views_blocks-term-block_1-5', context).each((i, element) => {
    if (!element.NewsSlider) {
      element.NewsSlider = new NewsSlider(element);
    }
  });

  // Resource Slidemenus

  $('.slidemenu.block .views-row', context).each((i, element) => {
    if (!element.Expanded) {
      element.Expanded = new Expanded(element);
    }
  });

  // Twitter Feed

  $('.twitter-feed', context).each((i, element) => {
    if (!element.TwitterFeed) {
      element.TwitterFeed = new TwitterFeed(element);
    }
  });

  // Controls the states of the menu and search states

  $('.site-toolbar', context).each((i, element) => {
    if (!element.toolbar) {
      element.toolbar = new Toolbar(element);
    }
  });

  // Controls the page overlay display

  $('.overlay', context).bind('click', () => {
    $body.removeClass('menu-active search-active');
  });

  // Hero and Term Banner Parallax Backgrounds

  $('.banner.block .field-image a', context).each((i, element) => {
    if (!element.Parallax) {
      element.Parallax = new Parallax(element);
      $body.addClass('has-banner');
    }
  });

  // Pod Background Images

  $('.pods.block .node, .home-pods.block .node', context).each((i, element) => {
    if (!element.BackgroundImage) {
      element.BackgroundImage = new BackgroundImage(element);
    }
  });

  // Add placeholder text to all text and textarea components.

  $('.node-webform .type-textfield, .node-webform .type-textarea', context).each((i, element) => {
    if (!element.Placeholder) {
      element.Placeholder = new Placeholder(element);
    }
  });

  // Fixed Header using Headroom.js

  $('.headroom', context).each((i, element) => {
    if (!element.headroom) {
      element.headroom = new Header(element);
    }
  });

  // Smart Footer

  $('.page-footer', context).each((i, footer) => {
    const $footprint = $('.footprint', context);
    if (!footer.smartFooter && $footprint.length) {
      footer.smartFooter = new SmartFooter(footer, $footprint);
    }
  });

  // Term Navigation

  $('.term-nav', context).each((i, element) => {
    if (!element.termNavigation) {
      element.termNavigation = new TermNavigation(element);
    }
  });

  // Photo Galleries

  $('.node-content .photo-gallery, .photo-gallery .node-image, .photo-gallery .node-upper-image', context).each((i, element) => {
    if (!element.gallery) {
      element.gallery = new Gallery(element);
    }
  });

  // Calendar of Events View

  $('.calendar-feed', context).each((i, element) => {
    if (!element.calendarFeed) {
      element.calendarFeed = new CalendarFeed(element);
    }
  });

  // Strip various header links

  $('.footer-links .node-header a, .overview .node-header a', context).each((i, element) => {
    if (!element.strip) {
      element.strip = new Strip(element);
    }
  });

  // Relocate Google Translate dependent on viewport
  $('.page-header', context).each((i, element) => {
    if (!element.Translate) {
      element.Translate = new Translate(element);
    }
  });

  // Add Sitemap output using the digitaldcore.js function

  const $map = $('#sitemap', context);
  const $nav = $('#sitemap .content', context);

  if ($map.length && $nav.length) {
    Drupal.digitaldcoreCreateSiteMap($map, $nav);
    $map.addClass('ready');
  }
});



// WEBPACK FOOTER //
// ./theme.js